<template>
  <a-modal title="新建订单" :visible="visible" :confirm-loading="loading" @cancel="cancel" @ok="ok">
    <a-form layout="vertical">
      <ak-type-input
        v-model="editorValue[0].editorValue"
        :field="filedsOptions[0]"
        :ref="filedsOptions[0].name"
      />
      <ak-type-input
        v-show="isShow"
        v-model="editorValue[1].editorValue"
        :field="filedsOptions[1]"
        :ref="filedsOptions[1].name"
      />
      <ak-type-input
        v-model="editorValue[2].editorValue"
        :field="filedsOptions[2]"
        :ref="filedsOptions[2].name"
      />
      <ak-type-input
        v-model="editorValue[3].editorValue"
        :field="filedsOptions[3]"
        :ref="filedsOptions[3].name"
      />
      <tk-flex :gutter="20" average>
        <ak-type-input
          v-model="editorValue[4].editorValue"
          :field="filedsOptions[4]"
          :ref="filedsOptions[4].name"
        />
        <ak-type-input
          v-model="editorValue[5].editorValue"
          :field="filedsOptions[5]"
          :ref="filedsOptions[5].name"
        />
      </tk-flex>
      <tk-flex :gutter="20" average>
        <ak-type-input
          v-model="editorValue[6].editorValue"
          :field="filedsOptions[6]"
          :ref="filedsOptions[6].name"
        />
        <div>
          <div style="color:rgba(0, 0, 0, 0.85)" class="m-b-8">税率</div>
          <a-select @change="handleChange">
            <a-select-option
              v-for="(item,index) in gdDynamicVariable"
              :key="index"
              :value="item"
            >{{item}}</a-select-option>
          </a-select>
        </div>
      </tk-flex>
      <ak-type-input
        v-model="editorValue[7].editorValue"
        :field="filedsOptions[7]"
        :ref="filedsOptions[7].name"
      />
      <tk-flex :gutter="20" average>
        <ak-type-input
          v-model="editorValue[8].editorValue"
          :field="filedsOptions[8]"
          :ref="filedsOptions[8].name"
        />
        <ak-type-input
          v-model="editorValue[9].editorValue"
          :field="filedsOptions[9]"
          :ref="filedsOptions[9].name"
        />
      </tk-flex>
      <tk-flex :gutter="20" average>
        <ak-type-input
          v-model="editorValue[10].editorValue"
          :field="filedsOptions[10]"
          :ref="filedsOptions[10].name"
        />
        <ak-type-input
          v-model="editorValue[11].editorValue"
          :field="filedsOptions[11]"
          :ref="filedsOptions[11].name"
        />
      </tk-flex>
      <ak-type-input
        v-model="editorValue[12].editorValue"
        :field="filedsOptions[12]"
        :ref="filedsOptions[12].name"
      />
      <ak-type-input
        v-model="editorValue[13].editorValue"
        :field="filedsOptions[13]"
        :ref="filedsOptions[13].name"
      />
      <ak-type-input
        v-model="editorValue[14].editorValue"
        :field="filedsOptions[14]"
        :ref="filedsOptions[14].name"
      />
    </a-form>
  </a-modal>
</template>

<script>
import NP from 'number-precision'
import Json from './../../assets/json/schema.json'
import store from '@/store'
const gdJson = Json
// const editFileds = ['finishProductid', 'costPrice', 'amount', 'clientid', 'packid', 'palletid', 'markid', 'shipDate', 'sellingPrice', 'profit', 'shipping', 'commission', 'remarks', 'pricePerTon', 'clientCommission', 'modelId']
const editFileds = ['finishProductid', 'costPrice', 'amount', 'clientid', 'packid', 'palletid', 'markid', 'shipDate', 'sellingPrice', 'shipping', 'remarks', 'pricePerTon', 'clientCommission', 'modelId', 'profit']
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      visible: false,
      loading: false,
      dynamicVariable: null,
      editorValue: [],
      gdDynamicVariable: [], // 税率
      pallet: null, // 托盘价格
      packing: null, // 包装价格
      profitRatio1: null, // 车间利系数
      profitRatio2: null, // 大类利系数
      amountRatio1: null, // 车间吨系数
      amountRatio2: null, // 大类吨系数
      orderProfit: null, // 型号利润
      isShow: true
    }
  },
  methods: {
    // 计算利润
    async getProfit () {
      await this.$tkHelper.sleep(300)

      if (this.editorValue[1].editorValue !== '' && this.editorValue[2].editorValue !== '' && this.editorValue[4].editorValue !== '' && this.editorValue[5].editorValue !== '' && this.editorValue[8].editorValue !== '' && this.editorValue[11].editorValue !== '' && this.editorValue[12].editorValue !== '') {
        if (this.profitRatio1 === null || this.profitRatio2 === null || this.amountRatio1 === null || this.amountRatio2 === null) {
          this.editorValue[14].editorValue = null
        } else {
          let { data: res1 } = await this.$tkParse.get('/settings')
          let amountCommissionRadix = res1.amountCommission
          let amountCommission = NP.round(NP.times(amountCommissionRadix, this.amountRatio1, this.amountRatio2), 2)
          let orderSalaryP = NP.round(NP.divide(NP.times(NP.minus(this.editorValue[8].editorValue, NP.times(this.dynamicVariable, this.editorValue[8].editorValue), this.editorValue[11].editorValue, this.editorValue[12].editorValue, this.packing, this.pallet, this.editorValue[1].editorValue), NP.times(this.profitRatio1, this.profitRatio2, this.editorValue[2].editorValue)), NP.plus(1, NP.times(this.profitRatio1, this.profitRatio2, this.editorValue[2].editorValue))), 2)
          let orderSalaryT = NP.round(NP.times(amountCommission, this.editorValue[2].editorValue), 2)
          // let profitP = NP.round(NP.minus(NP.minus(this.editorValue[8].editorValue, NP.times(this.editorValue[8].editorValue, this.dynamicVariable), this.editorValue[11].editorValue, this.editorValue[12].editorValue, this.packing, this.pallet, orderSalaryP), this.editorValue[1].editorValue), 2)
          // let profitT = NP.round(NP.minus(NP.minus(this.editorValue[8].editorValue, NP.times(this.editorValue[8].editorValue, this.dynamicVariable), this.editorValue[11].editorValue, this.editorValue[12].editorValue, this.packing, this.pallet, orderSalaryT), this.editorValue[1].editorValue), 2)
          // this.editorValue[14].editorValue = NP.round(Math.min(NP.times(NP.plus(profitP, this.orderProfit), this.editorValue[2].editorValue), NP.times(NP.plus(profitT, this.orderProfit), this.editorValue[2].editorValue)), 2)
          // this.editorValue[14].editorValue = NP.round(Math.min(NP.plus(profitP, NP.times(this.orderProfit, this.editorValue[2].editorValue)), NP.plus(profitT, NP.times(this.orderProfit, this.editorValue[2].editorValue))), 2)
          this.editorValue[14].editorValue = NP.round(NP.minus(NP.times(NP.minus(this.editorValue[8].editorValue, NP.times(this.editorValue[8].editorValue, this.dynamicVariable), this.editorValue[12].editorValue, this.packing, this.pallet, this.editorValue[1].editorValue), this.editorValue[2].editorValue), this.editorValue[9].editorValue, Math.max(orderSalaryP, orderSalaryT)), 2)
          // console.log('订单工资P', orderSalaryP, '订单工资T', orderSalaryT, '利润P', profitP, 'profitT', profitT, '车间利系数', this.profitRatio1, '大类利系数', this.profitRatio2, '车间吨系数', this.amountRatio1, '吨提成基数', amountCommissionRadix)
        }
      }
    },
    // 税率发生变化时调用
    handleChange (value) {
      this.dynamicVariable = value
      // this.calculationSellingPrice()
    },
    // 获取分式变量
    async getDynamicVariable () {
      const { data: res } = await this.$tkParse.get('/settings')
      let dynamicVariableArray = ['dynamicVariable', 'dynamicVariable1', 'dynamicVariable3', 'dynamicVariable4', 'dynamicVariable5']
      for (let i in res) {
        if (dynamicVariableArray.indexOf(i) !== -1) {
          let num = NP.divide(res[i], 100)
          this.gdDynamicVariable.push(num)
        }
      }
    },
    // 包装费 （托盘价与包装价0）
    async PackingFee () {
      // 查询托盘与包装价格
      if (this.editorValue[4].editorValue !== '') {
        let packing = await this.$tkParse.get('/classes/Pack/' + this.editorValue[4].editorValue).catch(e => {
          // 错误处理
        })
        this.packing = packing.data.price
      }
      if (this.editorValue[5].editorValue !== '') {
        let pallet = await this.$tkParse.get('/classes/Pallet/' + this.editorValue[5].editorValue).catch(e => {
          // 错误处理
        })
        this.pallet = pallet.data.price
      }
      // this.calculationSellingPrice()
    },
    // 计算售价
    // async calculationSellingPrice () {
    //   if (this.editorValue[1].editorValue !== '' && this.editorValue[4].editorValue !== '' && this.editorValue[5].editorValue !== '' && this.editorValue[8].editorValue !== '' && this.editorValue[10].editorValue !== '' && this.editorValue[11].editorValue !== '' && this.dynamicVariable !== '') {
    //     // 只有在有成本，包装，托盘，售价，运费，提成，税率全部有值时进行计算
    //     this.editorValue[9].editorValue = NP.round(NP.minus(NP.times(this.editorValue[8].editorValue, NP.minus(1, this.dynamicVariable)), NP.plus(this.editorValue[1].editorValue, this.editorValue[10].editorValue, this.editorValue[11].editorValue, this.packing, this.pallet)), 2)
    //   } else {
    //     this.editorValue[9].editorValue = ''
    //   }
    // },
    // 计算运费
    async calculationShpping () {
      if (this.editorValue[2].editorValue !== '' && this.editorValue[11].editorValue !== '') {
        // 只有在吨数和每吨运费都存在时进行计算
        this.editorValue[9].editorValue = NP.round(NP.times(this.editorValue[2].editorValue, this.editorValue[11].editorValue), 2)
      } else {
        this.editorValue[9].editorValue = ''
      }
    },
    // 匹配客户提成
    async getClientCommission () {
      if (this.editorValue[0].editorValue !== '' && this.editorValue[3].editorValue !== '') {
        let res = await this.$tkParse.getData(`/classes/clientCommission`, {
          params: {
            where: {
              finishProduct: this.editorValue[0].editorValue,
              Client: this.editorValue[3].editorValue
            }
          }
        })
        res.results.length ? this.editorValue[12].editorValue = res.results[0].clientCommission
          : this.editorValue[12].editorValue = 0
      }
    },
    // 匹配所属车间型号
    async getModelId () {
      if (this.editorValue[0].editorValue !== '') {
        let res = await this.$tkParse.getData(`/classes/finishProduct`, {
          params: {
            where: {
              objectId: this.editorValue[0].editorValue
            }
          }
        })
        res.results.length ? this.editorValue[13].editorValue = res.results[0].model : this.editorValue[13].editorValue = ''
      }
    },
    // 当型号为空时，重置
    resetfinishProductEffect () {
      this.editorValue[1].editorValue = 0
      this.shopManagementid = ''
      this.$forceUpdate()
    },
    // 获取所选型号详细信息
    async getfinishProductData (finishProductid) {
      if (!finishProductid) {
        this.resetfinishProductEffect()
      } else {
        const res = await this.$tkParse.getData(`/classes/finishProduct/${finishProductid}`)
        this.getPrice(res)
        this.getShopManagementData(res)
      }
    },
    // 获取型号车间
    async getShopManagementData (res) {
      this.shopManagementid = res.workShop
      this.getProfitRatio()
    },
    // 获取利系数
    async getProfitRatio () {
      let rs1 = await this.$tkParse.getData(`/classes/shopManagement/${this.shopManagementid}`)
      let rs2 = await this.$tkParse.getData(`/classes/shopManagement/${this.editorValue[13].editorValue}`)
      this.profitRatio1 = rs1.profitRatio1 ? rs1.profitRatio1 : null
      this.amountRatio1 = rs1.amountRatio1 ? rs1.amountRatio1 : null
      this.profitRatio2 = rs2.profitRatio2 ? rs2.profitRatio2 : null
      this.amountRatio2 = rs2.amountRatio2 ? rs2.amountRatio2 : null
    },
    // 获取型号成本价
    async getPrice (res) {
      let adjustment = 0 // 产品的附加费用
      // 获取成品数据
      if (res.adjustment) {
        adjustment = NP.plus(adjustment, res.adjustment) // 成品的调整值
      }
      // 获取成品的附加费
      const { data: surchargeData } = await this.$tkParse.get(`/classes/surcharge`, {
        params: {
          where: {
            proportion: res.proportion,
            type: 'finish'
          }
        }
      })
      if (surchargeData.results.length > 0) {
        if (surchargeData.results[0].profit) {
          this.orderProfit = surchargeData.results[0].profit
          adjustment = NP.plus(adjustment, surchargeData.results[0].profit) // 成品的利润
        }
        if (surchargeData.results[0].incidental) {
          adjustment = NP.plus(adjustment, surchargeData.results[0].incidental) // 成品的杂费
        }
      }
      // 获取成品的所有配料数据
      const arr = await Promise.all(res.formula.map(async ele => {
        if (ele.parts) {
          const data = await this.$tkParse.getData(`/classes/parts/${ele.parts}`)
          return {
            weight: ele.weight,
            data,
            type: 'parts'
          }
        } else {
          const data = await this.$tkParse.getData(`/classes/rawMaterial/${ele.rawMaterial}`)
          return {
            weight: ele.weight,
            data,
            type: 'rawMaterial'
          }
        }
      }))
      // 计算配料总重量
      const weight = arr.reduce((accumulator, target) => NP.plus(accumulator, target.weight), 0)
      // 计算配料价格
      let allPrice = 0
      arr.forEach(ele => {
        let price
        const elePrice = NP.round(NP.divide(ele.weight, weight), 4)
        if (ele.type === 'rawMaterial') {
          price = NP.times(ele.data.price, NP.divide(ele.data.rate, 100), elePrice)
        } else {
          price = NP.times(ele.data.price, elePrice)
        }
        allPrice = NP.plus(allPrice, price)
      })
      const finalMoney = NP.plus(allPrice, adjustment)
      this.editorValue[1].editorValue = Number(finalMoney.toFixed(2))
      this.$forceUpdate()
    },
    // 取消
    cancel () {
      this.$emit('complete', 'cancel')
    },
    // 确认
    async ok () {
      const flag = await this.validateValues()
      if (flag) {
        this.updateValue()
      } else {
        this.$notification.error({
          message: '信息填写有误',
          description: '信息填写有误'
        })
      }
    },
    // 新增订单
    async updateValue () {
      this.loading = !this.loading
      try {
        const data = {}
        this.editorValue.forEach(item => {
          data[item.key] = item.editorValue
        })

        data.verifyStatus = 'noVerify'
        data.userid = this.$store.state.user.objectId // 所属销售
        data.orderDate = new Date().toISOString() // 订货日期
        data.shopManagementid = this.shopManagementid // 所属车间
        data.taxRate = this.dynamicVariable
        data.userCompany = this.$store.state.user.company
        if (data.taxRate) {
          if (store.state.user.correlatedUser && store.state.user.correlatedUser.length) {
            data.status = 'financeVerify'
            await this.$modelAjax.post('verifyOrder', data)
            this.$notification.success({
              message: '保存成功',
              description: '数据已保存'
            })
            this.$emit('complete', 'cancel')
            this.vm.refresh()
          } else {
            data.status = 'add'
            await this.$modelAjax.post('Order', data)
            this.$notification.success({
              message: '保存成功',
              description: '数据已保存'
            })
            this.$emit('complete', 'cancel')
            this.vm.refresh()
          }
        } else {
          this.loading = !this.loading
          this.$notification.error({
            message: '保存失败',
            description: '税率不可为空'
          })
        }
      } catch (e) {
        this.loading = !this.loading
        this.$notification.error({
          message: '网络错误',
          description: '网络错误'
        })
      }
    },
    // 型号监听函数
    async watchHandlerToFinishProductid (newV) {
      this.getfinishProductData(newV)
    },
    isShowo () {
      if (store.state.user && Object.keys(store.state.user).indexOf('correlatedUser') !== -1 && store.state.user.correlatedUser.length) { this.isShow = false }
      // if (store.state.user && store.state.user.allClient === 'No' && Object.keys(store.state.user).indexOf('correlatedBy') === -1) { this.isShow = false }
    },
    // 验证填写信息
    async validateValues () {
      const arrRes = []
      for (const item in this.$refs) {
        const res = await this.$refs[item].validate()
        arrRes.push(res)
      }
      return arrRes.every(item => item === null)
    },
    // 生成v-model数据
    initEditorValue () {
      let copyFileds = this.$tkHelper.deepClone(this.editFileds)
      copyFileds.map(ele => {
        this.editorValue.push({ key: ele.name, editorValue: '' })
      })
    }
  },
  computed: {
    editFileds () {
      let fields = this.model.fields
      let copyFileds = this.$tkHelper.deepClone(fields)
      let copyJson = this.$tkHelper.deepClone(gdJson)
      for (let i in copyJson) {
        if (copyJson[i].className === 'Order') {
          for (let j in copyFileds) {
            const schema = copyJson[i].fields[copyFileds[j].name]
            copyFileds[j].schema = schema
          }
        }
      }
      return editFileds.map(ele => copyFileds.find(item => item.name === ele))
    },
    filedsOptions () {
      return this.editFileds.map(ele => {
        const data = Object.assign({}, ele, ele.schema)
        return data
      })
    }
  },
  async created () {
    if (store.state.user && store.state.user.allShopManagements === 'No') {
      this.$notification['error']({
        message: '数据异常',
        description: '缺少创建订单的必要属性，请先修改相应权限'
      })
    } else {
      this.visible = true
    }
    this.isShowo()
    this.initEditorValue()
    this.getDynamicVariable()
    this.unWatch0 = this.$watch(() => this.editorValue[0].editorValue, this.watchHandlerToFinishProductid)
    this.unWatch1 = this.$watch(() => this.editorValue[1].editorValue, this.getProfit)
    this.unWatch4 = this.$watch(() => this.editorValue[4].editorValue, this.PackingFee)
    this.unWatch44 = this.$watch(() => this.editorValue[4].editorValue, this.getProfit)
    this.unWatch5 = this.$watch(() => this.editorValue[5].editorValue, this.PackingFee)
    this.unWatch55 = this.$watch(() => this.editorValue[5].editorValue, this.getProfit)
    this.unWatch8 = this.$watch(() => this.editorValue[8].editorValue, this.getProfit)
    this.unWatch9 = this.$watch(() => this.editorValue[9].editorValue, this.getProfit)
    this.unWatch12 = this.$watch(() => this.editorValue[12].editorValue, this.getProfit)
    // this.unWatch11 = this.$watch(() => this.editorValue[11].editorValue, this.calculationSellingPrice)
    this.unWatch2 = this.$watch(() => this.editorValue[2].editorValue, this.calculationShpping)
    this.unWatch13 = this.$watch(() => this.editorValue[11].editorValue, this.calculationShpping)
    this.unWatch3 = this.$watch(() => this.editorValue[3].editorValue, this.getClientCommission)
    this.unWatch00 = this.$watch(() => this.editorValue[0].editorValue, this.getClientCommission)
    this.unWatch000 = this.$watch(() => this.editorValue[0].editorValue, this.getModelId)
    this.unWatch0000 = this.$watch(() => this.editorValue[0].editorValue, this.getProfit)
    this.unWatchs = this.$watch(() => this.dynamicVariable, this.getProfit)
  },
  destroyed () {
    if (this.unWatch0) {
      this.unWatch0()
      this.unWatch0 = null
    }
    // if (this.unWatch1) {
    //   this.unWatch1()
    //   this.unWatch1 = null
    // }
    // if (this.unWatch9) {
    //   this.unWatch9()
    //   this.unWatch9 = null
    // }
    // if (this.unWatch10) {
    //   this.unWatch10()
    //   this.unWatch10 = null
    // }
    // if (this.unWatch11) {
    //   this.unWatch11()
    //   this.unWatch11 = null
    // }
  }
}
</script>

<style></style>
